import { Injectable } from '@angular/core';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { MyOrganizationFacade, ProjectsFacade } from '@piqet-angular/data';
import {
  AccessPermissionService,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { iconConfigsArr } from '@piqet-angular/shared';
import { Subject, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ProjectReportGenerationDataGridService {
  inlineEditingSaveData = new Subject<boolean>();
  inlineEditingSaveData$ = this.inlineEditingSaveData.asObservable();

  constructor(
    private swalService: SwalService,
    private myOrganizationFacade: MyOrganizationFacade,
    private projectsFacade: ProjectsFacade,
    private accessService: AccessPermissionService
  ) {}

  accessPermission(): boolean {
    return this.accessService.hasPermission('edit', '', 'packaging');
  }

  cellRenderer(params: any) {
    const { value } = params;
    // Your rendering logic goes here...
    const cellDiv = document.createElement('div');
    cellDiv.textContent = value;
    return cellDiv;
  }

  getDataQualityAssessmentListGrid(): ColDef[] {
    let enableEditing: any;
    let resetData: any;
    let checkUpdateCircle = false;
    let newValue: any;
    let technologyId: any;
    let geographyRating: any;
    let temporalRating: any;
    let technoRating: any;
    let isCheckGeography = false;
    let isCheckTemporal = false;
    let isCheckTechnology = false;
    let technologyComment: string = '';
    let temporalComment: string = '';
    let geographyComment: string = '';
    let checkColumnValidate = false;
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'Name',
      headerName: 'Name',
      field: 'name',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      wrapHeaderText: true,
      maxWidth: grid_widths_map.sm_column_sm,
      cellRenderer: (params: any) => {
        if (!!params.value && params.value != '') {
          const materials = params.data?.materialList;
          //print materials line by line make it ul and li
          let materialList = '<ul class="small-text">';
          if (params.data?.isCustomMaterial && Array.isArray(materials)) {
            materials.forEach((material: any) => {
              materialList += `<li>${material}</li>`;
            });
            materialList += '</ul>';
            return `<div>
                    <div class="truncated-text setDataQualityAssesmentNameMargin dataQualityTruncate" title="${params.value}">${params.value}</div>
                    <div>${materialList}</div>
                  </div>
                  `;
          } else {
            return `<div class="truncated-text setDataQualityAssesmentNameMargin dataQualityTruncate" title="${params.value}">${params.value}</div>`;
          }
        } else {
          return ` <div style = "visibility: hidden; height:100px" > & nbsp; </div>`;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Process',
      headerName: 'Process',
      field: 'process',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        if (!!params.value && params.value != '') {
          return `<div class="truncated-text setDataQualityAssesmentMargin dataQualityTruncate" title="${
            params.value
          }">${
            params.value ? params.value : ''
          }</div>  <div style = "visibility: hidden;height:25px" > & nbsp; </div>`;
        } else {
          return ` <div style = "visibility: hidden; height:100px" > & nbsp; </div>`;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Data',
      headerName: 'Data',
      field: 'source',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      wrapHeaderText: true,
      maxWidth: grid_widths_map.sm_column_xm,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Geography',
      headerName: 'Geography',
      field: 'geography',
      cellClass: 'my-permission-cursor-pointer temporalClass',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      editable: true,
      cellEditor: 'DataQualityAssessmentDropdownComponent',
      cellEditorParams: {
        from: 'geography',
        editData: (data: any) => {
          geographyRating = data.geographyRating;
          geographyComment = data?.geographyComment;
          isCheckGeography = data?.isCheckGeography;
        },
      },
      cellRenderer: (params: any) => {
        const iconConfigs = iconConfigsArr;
        let { value } = params;
        const cellDiv = document.createElement('div');
        cellDiv.className = 'dataProcessKey';
        const truncatedTextDiv = document.createElement('div');
        truncatedTextDiv.className = 'truncated-text-input-quality';
        truncatedTextDiv.title = value;
        truncatedTextDiv.textContent = value;
        if (value == '') {
          truncatedTextDiv.style.height = '18px';
        }
        const cellDivTechnologyInput = document.createElement('div');
        cellDivTechnologyInput.innerText = !!params.data.geographyComment
          ? params.data.geographyComment
          : '';
        cellDivTechnologyInput.title = !!params.data.geographyComment
          ? params.data.geographyComment
          : '';
        cellDivTechnologyInput.className = 'input-dataQuality truncated-text-input-quality';
        let iconContainerDiv = document.createElement('div');
        iconContainerDiv.className = 'd-flex gap-1 pt-2';
        if (iconConfigs && Array.isArray(iconConfigs)) {
          iconConfigs.forEach(iconConfig => {
            const icon = document.createElement('i');
            icon.id = 'dataAssessmentQualityGeography' + params.rowIndex + '-' + iconConfig.value;
            iconContainerDiv.id =
              'dataAssessmentQualityGeographyDiv' + params.rowIndex + '-' + iconConfig.value;
            icon.className =
              'pointer-event ' +
              (iconConfig.value ==
              (!!geographyRating ? geographyRating : params.data.geographyRating)
                ? 'fa fa-circle'
                : 'fa fa-circle-thin');
            icon.style.color = iconConfig.color;
            icon.title = iconConfig.title;
            iconContainerDiv.appendChild(icon);
          });
        }
        cellDiv.append(truncatedTextDiv, cellDivTechnologyInput, iconContainerDiv);
        return cellDiv;
      },
      valueSetter: (params: any) => {
        let newVal = !!newValue ? newValue : '';
        const valueChanged =
          !!newValue && !resetData ? params.data[params.colDef.field] !== newVal : false;
        params.data = { ...params.data };
        if (!checkUpdateCircle) {
          this.checkEditOrNotCircle(params, params.data['geographyRating']);
          this.checkEditOrNotCircleForTemporal(params, params.data['temporalRating']);
          this.checkEditOrNotCircleForTechnology(params, params.data['technoRating']);
          geographyRating = params.data['geographyRating'];
          temporalRating = params.data['temporalRating'];
          technoRating = params.data['technoRating'];
          technologyId = params.data['technology'];
          newVal = params.data['technologyName'];
          geographyComment = params.data['geographyComment'];
        }
        if (checkColumnValidate) {
          params.data['technology'] =
            !!technologyId || technologyId === 0 ? technologyId : params.data['technology'];
          params.data['technologyName'] =
            newVal === 'null' ? '' : newVal != '' ? newVal : params.data['technologyName'];
          params.data['geographyRating'] = !!geographyRating
            ? geographyRating
            : params.data['geographyRating'];
          params.data['temporalRating'] = !!temporalRating
            ? temporalRating
            : params.data['temporalRating'];
          params.data['technoRating'] = !!technoRating ? technoRating : params.data['technoRating'];
          params.data['enableEditing'] = enableEditing;
          params.data['hasBeenEdited'] = true;
          params.data['geographyComment'] = isCheckGeography
            ? geographyComment
            : !!geographyComment && geographyComment != ''
            ? geographyComment
            : params.data['geographyComment'];
          this.projectsFacade.updateDataAnalysisTechnology(
            params.data,
            'edit',
            '',
            params.node.rowIndex
          );
          return valueChanged;
        } else {
          return true;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'TimePeriod',
      headerName: 'Temporal',
      field: 'timePeriod',
      cellClass: 'my-permission-cursor-pointer temporalClass',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      wrapHeaderText: true,
      editable: true,
      maxWidth: grid_widths_map.sm_column_xmd,
      minWidth: grid_widths_map.sm_column_xmd,
      cellEditor: 'DataQualityAssessmentDropdownComponent',
      cellEditorParams: {
        from: 'Temporal',
        editData: (data: any) => {
          temporalRating = data.temporalRating;
          temporalComment = data?.temporalComment;
          isCheckTemporal = data?.isCheckTemporal;
        },
      },
      cellRenderer: (params: any) => {
        const iconConfigs = iconConfigsArr;
        let { value } = params;
        const cellDivTemporal = document.createElement('div');
        cellDivTemporal.className = 'dataProcessKey';

        const truncatedTextDiv = document.createElement('div');
        truncatedTextDiv.className = 'truncated-text dataQualityTruncate';
        truncatedTextDiv.title = value;
        truncatedTextDiv.textContent = value;
        if (value == '') {
          truncatedTextDiv.style.height = '18px';
        }
        const cellDivTechnologyInput = document.createElement('div');
        cellDivTechnologyInput.innerText = !!params.data.temporalComment
          ? params.data.temporalComment
          : '';
        cellDivTechnologyInput.className = 'input-dataQuality truncated-text-input-quality';
        cellDivTechnologyInput.title = !!params.data.temporalComment
          ? params.data.temporalComment
          : '';
        let iconContainerDivTemporal = document.createElement('div');
        iconContainerDivTemporal.className = 'd-flex gap-1 pt-2';
        if (iconConfigs && Array.isArray(iconConfigs)) {
          iconConfigs.forEach(iconConfig => {
            const icon = document.createElement('i');
            icon.id = 'dataAssessmentQualityTemporal' + params.rowIndex + '-' + iconConfig.value;
            iconContainerDivTemporal.id =
              'dataAssessmentQualityTemporalDiv' + params.rowIndex + '-' + iconConfig.value;
            icon.className =
              'pointer-event ' +
              (iconConfig.value == (!!temporalRating ? temporalRating : params.data.temporalRating)
                ? 'fa fa-circle'
                : 'fa fa-circle-thin');
            icon.style.color = iconConfig.color;
            icon.title = iconConfig.title;
            iconContainerDivTemporal.appendChild(icon);
          });
        }
        cellDivTemporal.append(truncatedTextDiv, cellDivTechnologyInput, iconContainerDivTemporal);
        return cellDivTemporal;
      },
      valueSetter: (params: any) => {
        let newVal = !!newValue ? newValue : '';
        const valueChanged =
          !!newValue && !resetData ? params.data[params.colDef.field] !== newVal : false;
        params.data = { ...params.data };
        if (!checkUpdateCircle) {
          this.checkEditOrNotCircle(params, params.data['geographyRating']);
          this.checkEditOrNotCircleForTemporal(params, params.data['temporalRating']);
          this.checkEditOrNotCircleForTechnology(params, params.data['technoRating']);
          geographyRating = params.data['geographyRating'];
          temporalRating = params.data['temporalRating'];
          technoRating = params.data['technoRating'];
          technologyId = params.data['technology'];
          newVal = params.data['technologyName'];
          temporalComment = params.data['temporalComment'];
          geographyComment = params.data['geographyComment'];
        }
        if (checkColumnValidate) {
          params.data['technology'] =
            !!technologyId || technologyId === 0 ? technologyId : params.data['technology'];
          params.data['technologyName'] =
            newVal === 'null' ? '' : newVal != '' ? newVal : params.data['technologyName'];
          params.data['geographyRating'] = !!geographyRating
            ? geographyRating
            : params.data['geographyRating'];
          params.data['temporalRating'] = !!temporalRating
            ? temporalRating
            : params.data['temporalRating'];
          params.data['technoRating'] = !!technoRating ? technoRating : params.data['technoRating'];
          params.data['enableEditing'] = enableEditing;
          params.data['hasBeenEdited'] = true;
          params.data['temporalComment'] = isCheckGeography
            ? temporalComment
            : !!temporalComment && temporalComment != ''
            ? temporalComment
            : params.data['temporalComment'];
          params.data['geographyComment'] = isCheckGeography
            ? geographyComment
            : !!geographyComment && geographyComment != ''
            ? geographyComment
            : params.data['geographyComment'];
          this.projectsFacade.updateDataAnalysisTechnology(
            params.data,
            'edit',
            '',
            params.node.rowIndex
          );
          return valueChanged;
        } else {
          return true;
        }
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Technology',
      headerName: 'Technology',
      field: 'technology',
      cellClass: 'my-permission-cursor-pointer min-height-80',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      lockVisible: true,
      wrapHeaderText: true,
      cellEditor: 'DataQualityAssessmentDropdownComponent',
      cellEditorParams: {
        from: 'technology',
        editData: (data: any) => {
          newValue = data?.technologyName;
          technologyId = data?.technologyId;
          technoRating = data?.technoRating;
          technologyComment = data?.technologyComment;
          isCheckTechnology = data?.isCheckTechnology;
        },
      },
      cellRenderer: (params: any) => {
        const iconConfigs = iconConfigsArr;
        let { value } = params;
        // if (!value) return;
        const cellDivTechnology = document.createElement('div');
        cellDivTechnology.className = 'dataProcessKey';
        const truncatedTextDiv = document.createElement('div');
        truncatedTextDiv.className = 'truncated-text dataQualityTruncate';
        truncatedTextDiv.title = value;
        truncatedTextDiv.textContent = value;
        if (value == '') {
          truncatedTextDiv.style.height = '18px';
        }
        const cellDivTechnologyInput = document.createElement('div');
        cellDivTechnologyInput.innerText = !!params.data.technologyComment
          ? params.data.technologyComment
          : '';
        cellDivTechnologyInput.className = 'input-dataQuality truncated-text-input-quality';
        cellDivTechnologyInput.title = !!params.data.technologyComment
          ? params.data.technologyComment
          : '';
        let iconContainerDivTechnology = document.createElement('div');
        iconContainerDivTechnology.className = 'd-flex gap-1 pt-2';
        if (iconConfigs && Array.isArray(iconConfigs)) {
          iconConfigs.forEach(iconConfig => {
            const icon = document.createElement('i');
            icon.id = 'dataAssessmentQualityTechnology' + params.rowIndex + '-' + iconConfig.value;
            iconContainerDivTechnology.id =
              'dataAssessmentQualityTechnology' + params.rowIndex + '-' + iconConfig.value;
            icon.className =
              'pointer-event ' +
              (iconConfig.value == (!!technoRating ? technoRating : params.data.technoRating)
                ? 'fa fa-circle'
                : 'fa fa-circle-thin');
            icon.style.color = iconConfig.color;
            icon.title = iconConfig.title;
            iconContainerDivTechnology.appendChild(icon);
          });
        }
        cellDivTechnology.append(
          truncatedTextDiv,
          cellDivTechnologyInput,
          iconContainerDivTechnology
        );
        return cellDivTechnology;
      },
      valueSetter: (params: any) => {
        let newVal = !!newValue ? newValue : '';
        const valueChanged =
          !!newValue && !resetData ? params.data[params.colDef.field] !== newVal : false;
        params.data = { ...params.data };
        if (!checkUpdateCircle) {
          this.checkEditOrNotCircle(params, params.data['geographyRating']);
          this.checkEditOrNotCircleForTemporal(params, params.data['temporalRating']);
          this.checkEditOrNotCircleForTechnology(params, params.data['technoRating']);
          geographyRating = params.data['geographyRating'];
          temporalRating = params.data['temporalRating'];
          technoRating = params.data['technoRating'];
          technologyId = params.data['technology'];
          newVal = params.data['technologyName'];
          technologyComment = params.data['technologyComment'];
          temporalComment = params.data['temporalComment'];
          geographyComment = params.data['geographyComment'];
        }
        if (checkColumnValidate) {
          params.data['technology'] =
            !!technologyId || technologyId === 0 ? technologyId : params.data['technology'];
          params.data['technologyName'] =
            newVal === 'null' ? '' : newVal != '' ? newVal : params.data['technologyName'];
          params.data['geographyRating'] = !!geographyRating
            ? geographyRating
            : params.data['geographyRating'];
          params.data['temporalRating'] = !!temporalRating
            ? temporalRating
            : params.data['temporalRating'];
          params.data['technoRating'] = !!technoRating ? technoRating : params.data['technoRating'];
          params.data['enableEditing'] = enableEditing;
          params.data['hasBeenEdited'] = true;
          params.data['technologyComment'] = isCheckTechnology
            ? technologyComment
            : !!technologyComment && technologyComment != ''
            ? technologyComment
            : params.data['technologyComment'];
          params.data['temporalComment'] = isCheckTemporal
            ? temporalComment
            : !!temporalComment && temporalComment != ''
            ? temporalComment
            : params.data['temporalComment'];
          params.data['geographyComment'] = isCheckGeography
            ? geographyComment
            : !!geographyComment && geographyComment != ''
            ? geographyComment
            : params.data['geographyComment'];
          this.projectsFacade.updateDataAnalysisTechnology(
            params.data,
            'edit',
            '',
            params.node.rowIndex
          );
          this.projectsFacade.checkUpdateActionInterpretation$
            .pipe(take(1))
            .subscribe((flag: boolean) => {
              flag && this.inlineEditingSaveData.next(params.data);
            });
          geographyRating = null;
          technologyId = null;
          temporalRating = null;
          technoRating = null;
          newValue = null;
          isCheckTechnology = false;
          isCheckTemporal = false;
          isCheckGeography = false;
          checkColumnValidate = false;
          technologyComment = '';
          geographyComment = '';
          temporalComment = '';
          checkUpdateCircle = false;
          return valueChanged;
        } else {
          geographyRating = null;
          technologyId = null;
          temporalRating = null;
          technoRating = null;
          newValue = null;
          isCheckTechnology = false;
          isCheckTemporal = false;
          isCheckGeography = false;
          checkColumnValidate = false;
          technologyComment = '';
          geographyComment = '';
          temporalComment = '';
          checkUpdateCircle = false;
          return true;
        }
      },
      valueGetter: params => {
        return params.data.technologyName;
      },
      editable: true,
    });

    this.accessPermission() &&
      colDef.push({
        ...defaultColumn,
        colId: 'Actions',
        headerName: 'Actions',
        field: 'actions',
        sortable: false,
        minWidth: grid_widths_map.sm_column_xxm,
        maxWidth: grid_widths_map.sm_column_xs,
        cellRendererParams: {
          showInlineEdit: true,
          inlineEditData: (data: any) => {
            checkColumnValidate = true;
            enableEditing = data.data.enableEditing;
            checkUpdateCircle = !!data.data.isCheckUpdate ? data.data.isCheckUpdate : false;
          },
          editDataInlineReport: (params: any) => {
            const iconConfigs = iconConfigsArr;
            if (iconConfigs && Array.isArray(iconConfigs)) {
              iconConfigs.forEach(iconConfig => {
                const iconElement = document.getElementById(
                  `dataAssesmentQuality${params.rowIndex}-${iconConfig.value}`
                );
                const iconElementTemprol = document.getElementById(
                  `dataAssesmentQualityTemporal${params.rowIndex}-${iconConfig.value}`
                );
                // const iconElementDiv = document.getElementById(`dataAssesmentQualityDiv${params.rowIndex}-${iconConfig.value}`);
                if (iconElement) {
                  iconElement.classList.add('cursor-pointer');
                }
                if (iconElementTemprol) {
                  iconElementTemprol.classList.add('cursor-pointer');
                }
                // if (iconElementDiv) {
                //     iconElementDiv.style.borderBottom = '2px solid #9747FF';
                // }
              });
            }
          },
        },

        cellClass: 'my-permission-cursor-pointer',
        cellRenderer: 'inlineActionButtonComponent',
        lockVisible: true,
        lockPosition: right,
        resizable: false,
      });

    return colDef;
  }

  checkEditOrNotCircle(params: any, geographyRating: any) {
    const iconConfigs = iconConfigsArr;
    let value = params.data.process;
    if (!value) return;
    const cellDiv = document.createElement('div');
    cellDiv.className = 'dataProcessKey';

    const truncatedTextDiv = document.createElement('div');
    truncatedTextDiv.className = 'truncated-text';
    truncatedTextDiv.title = value;
    truncatedTextDiv.textContent = value;

    const iconContainerDiv = document.createElement('div');
    iconContainerDiv.className = 'd-flex gap-1 justify-content-end py-2';

    if (iconConfigs && Array.isArray(iconConfigs)) {
      iconConfigs.forEach(iconConfig => {
        const icon = document.createElement('i');
        icon.id = 'dataAssesmentQuality' + params.rowIndex + '-' + iconConfig.value;
        icon.className =
          'pointer-event ' +
          (iconConfig.value == params.data.geographyRating ? 'fa fa-circle' : 'fa fa-circle-thin');
        icon.style.color = iconConfig.color;
        icon.title = iconConfig.title;

        // Add click event listener to each icon

        const cellDefs = params.api.getEditingCells();
        if (!cellDefs.length) return;
        if (cellDefs[0].rowIndex != params.node.rowIndex) return;
        const clickedIconId = geographyRating;
        iconConfigs.forEach(config => {
          // Find the corresponding icon element in the HTML
          const iconElement = document.getElementById(
            `dataAssesmentQuality${params.node.rowIndex}-${config.value}`
          );
          if (iconElement) {
            // Update the class and color of the icon element
            if (config.value == clickedIconId) {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle';
              iconElement.style.color = config.color;
              geographyRating = geographyRating;
            } else {
              iconElement.className = 'cursor-pointer pointer-event fa fa-circle-thin';
              iconElement.style.color = config.color;
              geographyRating = geographyRating;
            }
          }
        });
        iconContainerDiv.appendChild(icon);
      });
    }
    cellDiv.append(truncatedTextDiv, iconContainerDiv);
    return cellDiv;
  }
  checkEditOrNotCircleForTemporal(params: any, temporalRating: any) {
    const iconConfigs = iconConfigsArr;
    let { value } = params;
    if (!value) return;
    const cellDivTemporal = document.createElement('div');
    cellDivTemporal.className = 'dataProcessKey';

    const truncatedTextDiv = document.createElement('div');
    truncatedTextDiv.className = 'truncated-text';
    truncatedTextDiv.title = value;
    truncatedTextDiv.textContent = value;

    let iconContainerDivTemporal = document.createElement('div');
    iconContainerDivTemporal.className = 'd-flex gap-1 justify-content-end py-2';
    if (iconConfigs && Array.isArray(iconConfigs)) {
      iconConfigs.forEach(iconConfig => {
        const icon = document.createElement('i');
        icon.id = 'dataAssessmentQualityTemporal' + params.rowIndex + '-' + iconConfig.value;
        iconContainerDivTemporal.id =
          'dataAssessmentQualityTemporalDiv' + params.rowIndex + '-' + iconConfig.value;
        icon.className =
          'pointer-event ' +
          (iconConfig.value == params.data.temporalRating ? 'fa fa-circle' : 'fa fa-circle-thin');
        icon.style.color = iconConfig.color;
        icon.title = iconConfig.title;
        // Add click event listener to each icon
        icon.addEventListener('click', (event: any) => {
          const cellDefs = params.api.getEditingCells();
          if (!cellDefs.length) return;
          if (cellDefs[0].rowIndex != params.rowIndex) return;
          const id = event.target.id;
          const clickedIconId = id.split('-')[1];
          iconConfigs.forEach(config => {
            // Find the corresponding icon element in the HTML
            const iconElement = document.getElementById(
              `dataAssessmentQualityTemporal${params.rowIndex}-${config.value}`
            );
            if (iconElement) {
              // Update the class and color of the icon element
              if (config.value == clickedIconId) {
                iconElement.className = 'cursor-pointer pointer-event fa fa-circle';
                iconElement.style.color = config.color;
                temporalRating = clickedIconId;
              } else {
                iconElement.className = 'cursor-pointer pointer-event fa fa-circle-thin';
                iconElement.style.color = config.color;
                temporalRating = clickedIconId;
              }
            }
          });
        });
        iconContainerDivTemporal.appendChild(icon);
      });
    }
    cellDivTemporal.append(truncatedTextDiv, iconContainerDivTemporal);
    return cellDivTemporal;
  }
  checkEditOrNotCircleForTechnology(params: any, technoRating: any) {
    const iconConfigs = iconConfigsArr;
    let { value } = params;
    if (!value) return;
    const cellDivTechnology = document.createElement('div');
    cellDivTechnology.className = 'dataProcessKey';

    const truncatedTextDiv = document.createElement('div');
    truncatedTextDiv.className = 'truncated-text';
    truncatedTextDiv.title = value;
    truncatedTextDiv.textContent = value;

    let iconContainerDivTechnology = document.createElement('div');
    iconContainerDivTechnology.className = 'd-flex gap-1 justify-content-end py-2';
    if (iconConfigs && Array.isArray(iconConfigs)) {
      iconConfigs.forEach(iconConfig => {
        const icon = document.createElement('i');
        icon.id = 'dataAssessmentQualityTechnology' + params.rowIndex + '-' + iconConfig.value;
        iconContainerDivTechnology.id =
          'dataAssessmentQualityTechnologyDiv' + params.rowIndex + '-' + iconConfig.value;
        icon.className =
          'pointer-event ' +
          (iconConfig.value == params.data.technoRating ? 'fa fa-circle' : 'fa fa-circle-thin');
        icon.style.color = iconConfig.color;
        icon.title = iconConfig.title;
        // Add click event listener to each icon
        icon.addEventListener('click', (event: any) => {
          const cellDefs = params.api.getEditingCells();
          if (!cellDefs.length) return;
          if (cellDefs[0].rowIndex != params.rowIndex) return;
          const id = event.target.id;
          const clickedIconId = id.split('-')[1];
          iconConfigs.forEach(config => {
            // Find the corresponding icon element in the HTML
            const iconElement = document.getElementById(
              `dataAssessmentQualityTechnology${params.rowIndex}-${config.value}`
            );
            if (iconElement) {
              // Update the class and color of the icon element
              if (config.value == clickedIconId) {
                iconElement.className = 'cursor-pointer pointer-event fa fa-circle';
                iconElement.style.color = config.color;
                technoRating = clickedIconId;
              } else {
                iconElement.className = 'cursor-pointer pointer-event fa fa-circle-thin';
                iconElement.style.color = config.color;
                technoRating = clickedIconId;
              }
            }
          });
        });
        iconContainerDivTechnology.appendChild(icon);
      });
    }
    cellDivTechnology.append(truncatedTextDiv, iconContainerDivTechnology);
    return cellDivTechnology;
  }

  alertConfirmation(data: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.myOrganizationFacade.deleteSKUProcessActions(data, 'delete');
      }
    });
  }
}
